import { Page } from '@app/hoc';
import { Typography } from '@app/components';

import { DashboardPeriodSelector } from './components/DashboardPeriodSelector';
import { DashboardTilesBand } from './components/DashboardTilesBand';
import { DashboardQrCodesBand } from './components/DashboardQrCodesBand';
import { DashboardFunnelBand } from './components/DashboardFunnelBand';
import { DashboardMoneyBand } from './components/DashboardMoneyBand';
import { DashboardUpcomingBand } from './components/DashboardUpcomingBand';
import { DashboardTodayBand } from './components/DashboardTodayBand';
import { useDashboardPeriod } from './hooks/useDashboardPeriod';

const BandTitle: React.FC<{ children: React.ReactNode; first?: boolean }> = ({ children, first }) => (
  <h2 className={`mb-2.5 text-[12px] font-bold uppercase tracking-wide text-gray-400 ${first ? 'mt-1.5' : 'mt-7'}`}>
    {children}
  </h2>
);

// admin-dashboard-opdracht.md - het lege dashboardscherm in het adminpaneel. §4's eigen
// leesvolgorde: vandaag -> nu -> wat er gemaakt wordt -> hoe kwamen we hier -> geld -> wat komt
// eraan. Band 4 always "now" (no period param); band 1/1b/2/3 respect the selector below - see
// AdminDashboardFacadeImpl's own javadoc for why that split exists.
export const AdminDashboardPage: React.FC = () => {
  const period = useDashboardPeriod();

  return (
    <Page
      title={
        <div className="mb-1 flex flex-wrap items-center justify-between gap-3">
          <Typography variant="h4">Dashboard</Typography>
          <DashboardPeriodSelector {...period} />
        </div>
      }
    >
      <div className="pb-10">
        {period.isToday && (
          <div className="mt-4">
            <DashboardTodayBand />
          </div>
        )}

        <BandTitle first>Nu</BandTitle>
        <DashboardTilesBand from={period.from} to={period.to} />

        <BandTitle>Wat er gemaakt wordt</BandTitle>
        <DashboardQrCodesBand from={period.from} to={period.to} />

        <BandTitle>De trechter — van aanmelding tot betaald</BandTitle>
        <DashboardFunnelBand from={period.from} to={period.to} />

        <BandTitle>Geld</BandTitle>
        <DashboardMoneyBand from={period.from} to={period.to} />

        <BandTitle>Wat eraan komt</BandTitle>
        <DashboardUpcomingBand />
      </div>
    </Page>
  );
};
